<button nz-button [type]="type" class="om-button" [style]="_buttonStyle" [disabled]="disabled" [nzLoading]="isLoading"
  [ngClass]="[iconOnly ? 'onlyIcon' : '', expand ? 'expand' : 'auto', color ? color : 'primary', size ? size : 'default' ]">
  <span *ngIf="svgIcon" nz-icon class="icon"><svg-icon [name]="svgIcon" ></svg-icon></span>
  <span *ngIf="antIcon" nz-icon class="icon" [nzType]="antIcon"></span>
  <ng-content #content></ng-content>
</button>
